/**
* @file 战队-战队扩容
* @author 余凯
*/

import React from 'react'
import { Tabs, Descriptions, Button, Modal, Table, InputNumber, Divider, message } from 'antd'
import './index.less'
import { connect } from 'react-redux'

import Actions from '@/apis/team'

const { confirm } = Modal;

const { TabPane } = Tabs;

const columns = [
  {
    title: '名次',
    dataIndex: 'name',
    width: 150,
  },
  {
    title: 'Age',
    dataIndex: 'age',
    width: 150,
  },
  {
    title: 'Address',
    dataIndex: 'address',
  },
];

const lvlList = [
  { lvl: '1级', count: '10人' },
  { lvl: '2级', count: '20人' },
  { lvl: '3级', count: '40人' },
  { lvl: '4级', count: '60人' },
  { lvl: '5级', count: '80人' },
  { lvl: '6级', count: '100人' },
  { lvl: '7级', count: '140人' },
]

@connect(
  state => state.teamReducer,

)
class TeamExpansion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      own: 0,
      visible: false,
      count: '',
      data: {}
    }
  }

  componentDidMount() {
    this.getData()
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleChangeInput = v => {
    const { data } = this.state
    const { value } = v.target
    if (value > data.rest_num) {
      this.setState({
        count: data.rest_num
      })
      return message.error('最多还能扩容' + data.rest_num + '人')
    }
    this.setState({
      count: value
    })
  }

  showConfirm = () => {
    const { count } = this.state
    const _this = this
    if (count > 0) {
      confirm({
        title: '扩容确认通知',
        content: '您将花费' + 10 * count + '万金蛋扩容' + count + '人，请确认！',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          const params = {
            id: _this.props.userInfo.game_team_id,
            game_id: _this.props.game,
            member_number: count
          }
          Actions.putExpandInfo(params).then(res => {
            if (res.code == 200) {
              message.success('扩容成功')
            }
            _this.getData()
          })
        },
        onCancel() { },
      });
    }
  }

  getData = async () => {
    const paramas = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game
    }
    const res = await Actions.getExpandInfo(paramas)
    if (res.code == 200) {
      this.setState({
        data: res.data
      })
    }
  }

  render() {
    const { count, data } = this.state
    return (
      <div className="team_expansion" id="team_expansion">
        <div className="team_wrap">
          <div className="team_name">战队扩容</div>
          <Descriptions column={2} title="战队详情">
            <Descriptions.Item label="战队等级">
              {data.level}
级
            </Descriptions.Item>
            <Descriptions.Item label="基础人数">
              {data.base_member}
人
            </Descriptions.Item>
            <Descriptions.Item label="您已扩容">
              {data.expand_num}
人
            </Descriptions.Item>
            <Descriptions.Item label="还能扩容">
              {data.rest_num}
人
            </Descriptions.Item>
            <Descriptions.Item label="我要扩建">
              <InputNumber value={count}
                min={1}
                onChange={value => this.setState({ count: value })}
                onBlur={this.handleChangeInput}
                placeholder="人数" />
            </Descriptions.Item>
          </Descriptions>
          <Button type="primary" onClick={this.showConfirm}>
            确认扩容
          </Button>
          <Divider />
          <div className="expansion_tip">
            <Descriptions column={1} title="扩容须知">
              <Descriptions.Item label="">1. 根据战队等级允许战队扩建相应的人数上限。</Descriptions.Item>
              <Descriptions.Item label="">2. 每扩建1人上限需支付10万金蛋费用。</Descriptions.Item>
              <Descriptions.Item label="">3. 扩建完成的人数上限无时间限制不会下降。</Descriptions.Item>
            </Descriptions>

          </div>

        </div>
        <div className="leaderboard">
          <div className="title">
            &nbsp;
          </div>
          <div className="table">
            <table>
              <thead>
                <tr>
                  <th>战队等级</th>
                  <th>可扩容人数</th>
                </tr>
              </thead>
              <tbody>
                {lvlList.map((v, i) => (
                  <tr key={v}>
                    <td className="table_id" >{v.lvl}</td>
                    <td className="table_name">{v.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <Modal
          className="home_reward_wrap"
          title="战队奖励"
          visible={this.state.visible}
          footer={null}
          getcontainer={false}
          // onOk={this.handleOk}
          onCancel={() => this.setState({
            visible: false
          })}
        >
          <Table
            // bordered
            // title={() => '我的名次'}
            size="small"
            columns={columns}
            dataSource={data}
            // pagination={{"pageSize": 10}}
            scroll={{ y: 240 }} />
        </Modal>
      </div>
    );
  }
}

export default TeamExpansion;
